export function createProperty(id: string, value: string): string {
  return `<property id="${id}">${value?.toXmlString() ?? ''}</property>`;
}
